// removed by extract-text-webpack-plugin
module.exports = {"xrColorPrimary":"#2362FB"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41119a52","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/Users/wdx0210/webProject/publicHealth-web/src/styles/xr-theme.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PageDesigner/index.vue
// module id = H+vk
// module chunks = 232